<template>
    <div class="bg-white overflow-hidden shadow rounded-lg m-auto w-3/5 one-page">

        <div v-if="tempSection.header_image_url" class="text-center w-100">
            <img class="object-cover h-auto w-auto mb-5" :src="tempSection.header_image_url">
        </div>

        <div class="px-4 py-5 sm:p-6 min-h-screen-60" style="padding-top:0 !important;font-size:15px;">
            <div class="">
                <div @change="changeInputs" :id="'content'+section.id" v-html="section.text" v-model="section.text"></div>
            </div>

            <div class="mt-5 flex justify-center">
                <table v-if="section.signature_section" class="table-auto">
                    <tr>
                        <th colspan="3" class="px-2 text-white" :style="colorStyle" style=" border: 1px solid #000; text-weight: 200;">
                            Please confirm your acceptance of this quote by signing this document
                        </th>
                    </tr>
                    <tr>
                        <td style="color:#aaa; border: 1px solid #000; padding: 2px">{{ tempSection.signer && tempSection.signer.signed_name ? tempSection.signer.signed_name : 'Signature' }}</td>
                        <td style="color:#aaa; border: 1px solid #000; padding: 2px">{{ tempSection.signer && tempSection.signer.signed_name ? tempSection.signer.signed_name : 'Print Name' }}</td>
                        <td style="color:#aaa; border: 1px solid #000; padding: 2px">{{ tempSection.signer ? tempSection.signer.created_at.moment('m/d/Y h:i:s A') : 'Date' }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="page-number">
            {{page}}
        </div>
        <div v-if="tempSection.footer_image_url" class="border-gray-200 mt-5 proposal-footer">
            <img class="object-cover h-auto" style="width: 100%!important;height: auto !important;" :src="tempSection.footer_image_url">
        </div>

    </div>
</template>

<script>
import CkeditorProposal from "../../shared/ckeditor-proposal";
import axios            from "axios";
export default {
    components: {CkeditorProposal},
    props: ['section', 'tempSection', 'token', 'page'],
    name: "preview-introduction",
    computed: {
        colorStyle() {
            return {
                "background-color": this.tempSection.color,
                section: this.section,
            };
        }
    },
    methods: {
        changeInputs() {

            let self = this;
            let allinputs = document.querySelectorAll('#content'+self.section.id+' input');
            let myLength = allinputs.length;
            let input;
            let newContent;

            for (let i = 0; i < myLength; ++i) {
                input = allinputs[i];
                if (input.value) {
                    input.defaultValue = input.value
                    newContent = document.querySelectorAll('#content'+self.section.id)[0].innerHTML;
                }
            }
            self.section.text = newContent;

            axios.put(route('proposal.update-introduction-section', {token:self.token}), {section: self.section})
                .then(()=>{})

        }
    }
}
</script>

<style scoped>
p {
    margin-top:0;
    margin-bottom:0;
}
table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
}
table td {
    border: 1px solid #000;
    padding: 2px 5px;
    outline: none;
}
.section-header {
    width: 50%;
    margin-top: 50px;
}

.section-name {
    color: #303941;
    font-size: 25px;
    font-weight: bold;
    text-transform: uppercase;
    font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.section-text {
    color: #303941;
    font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.ql-align-center {
    text-align: center;
}

.ql-align-right {
    text-align:right;
}

.ql-align-justify {
    text-align: justify;
}

.ql-font-monospace {
    font-family: monospace;
}

.ql-font-serif {
    font-family: serif;
}

.header-image {
    position: fixed;
    top: -50px;
    padding-right: -50px;
    padding-left: -50px;
    padding-bottom: -50px;
    width: 100%;
}

.footer-image {
    position: fixed;
    bottom: 100px;
    margin-top: 20px;
    padding-left: -50px;
    padding-right: -50px;
    width: 100%;
}

.image.image_resized {
    display: block;
    box-sizing: border-box;
}

.image.image_resized img {
    width: 100%;
}

.image.image_resized > figcaption {
    display: block;
}

.todo-list {
    list-style: none;
}

.todo-list__label__description {
    margin-left: 5px;
    margin-top: 2px;
    position: absolute;
}
.page-number{
    background: #fff;
    padding: 5px 15px;
    border-radius: 5px;
    position: absolute;
    bottom: 15px;
    right: 15px;
    box-shadow: 0px 0px 1px 1px #444;
    z-index: 999;
}
table {
    width: 100%;
}
table, th, td{
    border:1px solid #b9b9b9;
}
th{
    text-align: center !important;
    background-color: #f0f0f0;
}
@media print {
    @page {
        margin: 0cm !important;
    }
}
</style>
